import { Hammer } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { useTenantNullable } from '@/hooks/use-tenant';

export function AppUnderConstructionBar() {
  const { LL } = useI18nContext();
  const tenant = useTenantNullable();

  if (!tenant?.isAppUnderConstruction) {
    return null;
  }

  return (
    <div className="flex w-full shrink-0 items-center justify-center gap-2 bg-primary px-4 py-1.5 text-center text-primary-foreground max-md:flex-wrap">
      <Hammer className="size-4 shrink-0" />
      <span className="text-sm">{LL.appUnderConstructionBar.message()}</span>
    </div>
  );
}
